import React, { useState, useRef, useEffect } from 'react'
import { Button, Text } from '@maui/elements'

export const TextClamp = ({ children, ...props }) => {
  const { clamp = 3, ...rest } = props
  const [expanded, setExpanded] = useState(false)
  const contentRef = useRef(null)
  const [numLines, setNumLines] = useState(0)

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = parseFloat(getComputedStyle(contentRef.current).lineHeight)
      const numLines = Math.floor(contentRef.current.clientHeight / lineHeight)
      setNumLines(numLines)
      setExpanded(numLines < clamp)
    }
  }, [children, clamp])

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  return (
      <>
        <Text
          ref={contentRef}
          as="p"
          maxWidth="100%"
          style={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: expanded ? 'unset' : clamp,
            display: '-webkit-box',
            overflow: 'hidden',
          }}
          textOverflow="ellipsis"
          marginY="spaceGapMedium"
          lineHeight="1.3"
          {...rest}
          >
          {children}
          </Text>
          {
            numLines >= clamp &&
              <Button
                onClick={toggleExpanded}
                variant='text'
                p='0'>
                {!expanded ? 'Show More' : 'Show Less'}
              </Button>
          }
      </>
  )
}
